import axios from "@axios";

export default {
  getOrganizations() {
    return axios.get("/organizations");
  },
  getManagers() {
    return axios.get("/users/for-select", {
      params: { org_role: "manager" },
    });
  },
  getUsers() {
    return axios.get("/users/for-select", { params: { org_role: "user" } });
  },
  getAllUsers() {
    return axios.get("/users/for-select");
  },
  getCameras() {
    return axios.get("/ai-camera/cameras");
  },

  getPersonnelImages(filters, page = 1, perPage = 10) {
    const payload = { ...filters };

    const formatDateTime = (val) => {
      if (!val) return val;
      const cleanVal = val.trim();
      if (cleanVal.length === 10) return `${cleanVal} 00:00:00`;
      if (cleanVal.length === 16) return `${cleanVal}:00`;
      return cleanVal;
    };

    if (payload.start_date)
      payload.start_date = formatDateTime(payload.start_date);
    if (payload.end_date) payload.end_date = formatDateTime(payload.end_date);

    const cleanFilters = Object.keys(payload).reduce((acc, key) => {
      if (
        payload[key] !== null &&
        payload[key] !== "" &&
        !(Array.isArray(payload[key]) && payload[key].length === 0)
      ) {
        acc[key] = payload[key];
      }
      return acc;
    }, {});

    return axios.post("/ai-camera/personal-images", cleanFilters, {
      params: { page, per_page: perPage },
    });
  },
};
